export const getThreadSidebarNavigation = (
  unreadPostCommentCount: number,
  unreadMentionCount: number,
) => ({
  favorites: { to: "/favorites" as const, hasUnread: false },
  following: {
    to: "/following" as const,
    hasUnread: unreadPostCommentCount > 0 || unreadMentionCount > 0,
  },
});

export const formatFollowingAccessibleLabel = (
  label: string,
  unreadLabel: string,
) => `${label}、${unreadLabel}`;
